import React from 'react';
import QrTable from 'main/table/QrTable';
import PropTypes from 'prop-types';
export const QrMatchTable = React.forwardRef((props,ref)=>{

	let className = "";
	if(props.scanCount > 0 && (props.scanStatus === "Matched")){
		className = "qr-scan-match";
	}

	return(
		<div className={className}>
			<QrTable ref={ref} dataType="match" target="self" isFixedDataType={true}/>
		</div>
	)

});
QrMatchTable.propTypes = {
	scanStatus: PropTypes.string,
	scanCount:PropTypes.number,
	handleScan: PropTypes.func
};
QrMatchTable.displayName = "QrMatchTable";
